import React from 'react';
import { theme } from 'antd';
import { IconChevronRight } from '@tabler/icons-react';

interface SettingsListRowProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

/**
 * Mobile "Configuración" section-list row (icon + label + chevron) --
 * deliberately the same hairline-divided-row pattern as ProfileMobile's own
 * ProfileMenuRow (ajustes/panel de administración/idioma/cerrar sesión),
 * not a bordered card per row, so both screens in the Perfil area read as
 * the same reused list component. Only used here (Settings.tsx) as of this
 * writing -- if a future caller wants the individually-bordered-card look
 * instead, add a variant prop rather than changing this default.
 */
const SettingsListRow: React.FC<SettingsListRowProps> = ({ icon, label, onClick }) => {
  const { token } = theme.useToken();

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        padding: '14px 4px',
        border: 'none',
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        background: 'none',
        textAlign: 'left',
        cursor: 'pointer',
        fontSize: 15,
        color: token.colorText,
      }}
    >
      {icon}
      <span style={{ flex: 1 }}>{label}</span>
      <IconChevronRight size={16} color={token.colorTextTertiary} />
    </button>
  );
};

export default SettingsListRow;
